import {Controller} from "stimulus"
import $ from 'jquery';
import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es";
import {get} from "@rails/request.js";

let add_to_date = (year, month, day, hours, minute, min = 0, delay = 0, max = 0, hours_add = 1, server_date = null) => new Promise((resolve, reject) => {
    let calc_hours = parseInt(hours) + hours_add;
    if (`${calc_hours}`.length === 1) {
        calc_hours = `0${calc_hours}`;
    }
    let date = new Date(`${year}-${month}-${day}T${calc_hours}:00:00`);
    // Convertir la diferencia a horas dividiendo por 60
    let diferenciaHoras = date.getTimezoneOffset() / 60;
    let miliseconds_hours = diferenciaHoras * 3600000;

    let start_date = new Date(`${year}-${month}-${day}T${calc_hours}:00:00`).getTime();
    start_date = new Date(start_date - miliseconds_hours);

    let from_server_now = null;
    let min_date = new Date(`${year}-${month}-${day}T${calc_hours}:00:00`).getTime();
    min_date = new Date(min_date - miliseconds_hours);
    let max_date = null;
    let min_time = '00:00'
    start_date = start_date.setDate(start_date.getDate() + delay);
    start_date = new Date(start_date);
    min_date = min_date.setDate(min_date.getDate() + min);
    min_date = new Date(min_date);

    /* Código por el cambio de horario de verano */
    let cambio_horario_verano = false;
    if (!determinarHorarioVerano(date) && determinarHorarioVerano(start_date)) {
        start_date = start_date.setHours(start_date.getHours() + 1);
        cambio_horario_verano = true;
    } else if (determinarHorarioVerano(date) && !determinarHorarioVerano(start_date)) {
        start_date = start_date.setHours(start_date.getHours() - 1);
        cambio_horario_verano = true;
    }
    if (cambio_horario_verano) {
        start_date = new Date(start_date);
    }
    /* Código por el cambio de horario de verano FINN */


    if (max > 0) {
        max_date = new Date(`${year}-${month}-${day}T${calc_hours}:00:00`);
        max_date = new Date(max_date - miliseconds_hours);
        max_date = max_date.setDate(max_date.getDate() + max);
        max_date = new Date(max_date);

        remake_date(max_date.toISOString()).then(max => {
            max_date = max;
        });
    }
    remake_date(min_date.toISOString()).then(
        min => {
            min_date = min;
        }
    )
    remake_date(start_date.toISOString()).then(
        start => {
            start_date = start;
        }
    )
    if (server_date !== null) {
        let calc_hours_from_server = parseInt(server_date[3]);
        if (`${calc_hours_from_server}`.length === 1) {
            calc_hours_from_server = `0${calc_hours_from_server}`;
        }
        from_server_now = new Date(`${server_date[0]}-${server_date[1]}-${server_date[2]}T${calc_hours_from_server}:00:00`);
        remake_date(from_server_now.toISOString()).then(
            from => {
                from_server_now = from;
            }
        )
    }

    setTimeout(() => {
        resolve({
            min: min_date,
            start: start_date,
            max: max_date,
            from_server: from_server_now
        })
    }, 500)
})

/* Para el tema de la hora estándar y la de verano */
let determinarHorarioVerano = (date) => {
    // Crear objeto Date con la fecha proporcionada
    let fecha = new Date(date);

    // Calcular el tiempo en milisegundos desde la época
    let timestamp = fecha.getTime();

    // Definir los límites de tiempo para el horario de verano
    let inicioVerano = new Date('2025-03-09T00:00:00');
    let finVerano = new Date('2025-11-02T00:00:00');

    // Convertir los límites a timestamps
    let inicioVeranoTimestamp = inicioVerano.getTime();
    let finVeranoTimestamp = finVerano.getTime();

    // Comprobar si la fecha está dentro del período de verano
    return timestamp >= inicioVeranoTimestamp && timestamp < finVeranoTimestamp;
}
/* Para el tema de la hora estándar y la de verano FINN */

let remake_date = (date) => new Promise((resolve, reject) => {
    let date_string = date.split('T')[0];
    let hour_string = date.split('T')[1];

    let minified_year = date.split('T')[0].split('-');
    minified_year[0] = minified_year[0].slice(2, 4);
    minified_year = minified_year.reverse().join('/');

    date_string = date_string.split('-');
    date_string = date_string.reverse().join('/')

    hour_string = hour_string.replace(':00.000Z', '');
    resolve({
        date: date_string,
        minified: minified_year,
        time: hour_string
    });
})

function formatState (row) {
    console.log(row)
    if (!row.id) {
        return 'Este elemento esta corrupto.';
    }
    let text = row.text.split('|')
    var response = $(
        '<span><img src="' + text[0]+ '" class="img-flag" /> ' + text[1] + '</span>'
    );
    return response;
};

function formatRepoSelection (row) {
    let text = row.text.split('|')
    return text[1] || row.text
}

export default class extends Controller {
    static targets = ["agencySelect", "destiationsSelect", "dealerSelect", "officeSelect", "productSelect", "productDetails", "additionalData", "additionalDrivers", "contractSelect", "modalitySelect", "tariffSelect", "departuresField", "departuresHoursField", "dropField", "dropHoursField", "priceDetails", "airport", "userMessage", "responsabilitySupply", "paxAirportSelect", "clientCountry"]

    initialize() {
        setTimeout(() => {

            let context = this;
            this.count_dealer_options = [];
            this.own_product = false;
            this.not_own_product_area = $('#not-own-product');
            this.hours_diference = 24;
            $.datetimepicker.setLocale('es');

            flatpickr(`#${this.departuresFieldTarget.id}`, {
                altInput: true,
                altFormat: "d/m/y",
                dateFormat: "d/m/y",
                minDate: this.departuresFieldTarget.dataset.date,
                defaultDate: this.departuresFieldTarget.dataset.date,
                locale: Spanish
            });

            flatpickr(`#${this.dropFieldTarget.id}`, {
                altInput: true,
                altFormat: "d/m/y",
                dateFormat: "d/m/y",
                minDate: this.dropFieldTarget.dataset.date,
                defaultDate: this.dropFieldTarget.dataset.date,
                locale: Spanish
            });

            // OFICINAS
            if (this.hasOfficeSelectTarget) {
                $(this.officeSelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción"
                }).prop('disabled', true).on('select2:select', function () {
                    let event = new Event('change', {bubbles: true})
                    this.dispatchEvent(event);
                })
            }
            // MODALIDADES
            if (this.hasModalitySelectTarget) {
                $(this.modalitySelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción",
                    allowClear: true
                }).prop('disabled', true).on('select2:select', function () {

                    let event = new Event('change', {bubbles: true})
                    this.dispatchEvent(event);
                });
            }

            // TARIFAS
            if (this.hasTariffSelectTarget) {
                $(this.tariffSelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción",
                    allowClear: true
                }).prop('disabled', true).on('select2:select', function () {

                    let event = new Event('change', {bubbles: true})
                    this.dispatchEvent(event);
                });
            }
            // CONTRATOS
            if (this.hasContractSelectTarget) {
                $(this.contractSelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción",
                    allowClear: true
                }).prop('disabled', true).on('change.select2', () => {
                    // if (this.contractSelectTarget.options.length === 1) {
                    if (!this.own_product) {
                        this.getTariffs();
                    }
                    // }
                });
            }
            // PRESTATARIOS
            if (this.hasDealerSelectTarget) {
                let dealerSelect2 = $(this.dealerSelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción",
                    allowClear: true
                });

                dealerSelect2.prop('disabled', true).on('change.select2', () => {
                    if (this.dealerSelectTarget.options.length === 1) {
                        context.getOffices();
                        context.getContracts();
                    }
                });
            }
            // DESTINOS
            if (this.hasDestiationsSelectTarget) {
                $(this.destiationsSelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción",
                    allowClear: true
                }).prop('disabled', true).on('change.select2', function () {
                    context.getDealers(true);
                    context.getAditionalData();
                });

            }
            // PRODUCTOS
            if (this.hasProductSelectTarget) {
                $(this.productSelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción",
                    allowClear: true,
                    templateResult: formatState,
                    templateSelection: formatRepoSelection
                }).prop('disabled', true).on('change.select2', () => {
                    this.getModalities(true);
                    this.getDestination();
                    this.getProductDataForSeason();
                });
            }
            // AGENCIAS
            if (this.hasAgencySelectTarget) {
                let agencySelect2 = $(this.agencySelectTarget).select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione una opción",
                    allowClear: true
                });

                // Contar cantidad de options del select de agencias
                let count_options = [];
                $(this.agencySelectTarget).find('option').map((index, elem) => {
                    if (elem.value.length > 0) {
                        count_options.push(elem.value);
                    }
                })
                agencySelect2.prop('disabled', true).on('change.select2', () => {

                    if (context.productSelectTarget.selectedOptions.length > 0 && context.productSelectTarget.selectedOptions[0].value !== '') {
                        this.getProductDataForSeason();
                    }
                    this.getProducts();

                });

                // Disparar evento change de el select de agencia si hay un solo option para seleccionar

                // if (count_options.length === 1) {
                agencySelect2.trigger({
                    type: 'change.select2'
                });
                // }
            }
        }, 2000)
    }

    connect() {
        let context = this;
        let departure = $(this.departuresFieldTarget);
        let departure_hours = $(this.departuresHoursFieldTarget);
        let dropField = $(this.dropFieldTarget);
        let dropHoursField = $(this.dropHoursFieldTarget);
        let clientCountry = $(this.clientCountryTarget);
        let add_hours = 1;
        clientCountry.prop('disabled', true)


        if (this.departuresFieldTarget.dataset.value !== undefined) {
            let date_from = this.departuresFieldTarget.value;
            departure.prop('disabled', true)
            departure_hours.prop('disabled', true)
            dropHoursField.prop('disabled', true)
        }


        $(this.dropFieldTarget).on('change', (e) => {
            context.getProductsDetails(true, true, true, true, false)
        })

        setTimeout(() => {
            context.getProductsDetails(true, true, true, true, false)
        }, 6000)
    }


    getDestination() {
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let product = this.productSelectTarget.selectedOptions[0].value;
        let target = this.destiationsSelectTarget.id
        get(`/admin/get_destinations`, {
            query: {
                id: agency,
                product: product,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            setTimeout(() => {
                if (this.destiationsSelectTarget.dataset.value !== undefined) {
                    $(this.destiationsSelectTarget).val(this.destiationsSelectTarget.dataset.value); // Change the value or make some change to the internal state
                    $(this.destiationsSelectTarget).trigger('change.select2');
                }
            }, 500)
        })
    }

    getDealers(initial_load = false) {
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let destination = this.destiationsSelectTarget.selectedOptions[0].value;
        let product = this.productSelectTarget.selectedOptions[0].value;
        let target = this.dealerSelectTarget.id

        get(`/admin/get_dealers`, {
            query: {
                id: agency,
                destination: destination,
                product: product,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.setDealerData(initial_load);
        })
    }

    setDealerData(initial_load) {
        if (initial_load) {
            setTimeout(() => {
                if (this.dealerSelectTarget.dataset.value !== undefined) {
                    $(this.dealerSelectTarget).val(this.dealerSelectTarget.dataset.value); // Change the value or make some change to the internal state
                    $(this.dealerSelectTarget).trigger('change.select2');
                }
            }, 500)
        }
    }

    getOffices() {
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let destination = this.destiationsSelectTarget.selectedOptions[0].value;
        let product = this.productSelectTarget.selectedOptions[0].value;
        let dealer = this.dealerSelectTarget.selectedOptions[0].value;
        let target = this.officeSelectTarget.id

        get(`/admin/get_offices`, {
            query: {
                id: dealer,
                destination: destination,
                product: product,
                agency: agency,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            setTimeout(() => {
                if (this.officeSelectTarget.dataset.value !== undefined) {
                    $(this.officeSelectTarget).val(this.officeSelectTarget.dataset.value); // Change the value or make some change to the internal state
                    $(this.officeSelectTarget).trigger('change.select2');
                }
            }, 500)
        })
    }

    getOfficeById() {
        this.getProductDataForSeason('departure')
    }

    getProducts() {
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let target = this.productSelectTarget.id

        get(`/admin/get_products`, {
            query: {
                agency: agency,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.setProductData();
        })
    }

    setProductData() {
        setTimeout(() => {
            if (this.productSelectTarget.dataset.value !== undefined) {
                $(this.productSelectTarget).val(this.productSelectTarget.dataset.value); // Change the value or make some change to the internal state
                $(this.productSelectTarget).trigger('change.select2');
            }
        }, 500)
    }

    getProductsDetails(show_load = true, refresh_details = true, refresh_price = true, refresh_message = false, show_description = false) {
        let id_voucher = ''
        if ($('#voucher_id') !== undefined) {
            id_voucher = $('#voucher_id').val();
        }
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let destination = this.destiationsSelectTarget.value;
        let oficina = this.officeSelectTarget.value;
        let product = this.productSelectTarget.selectedOptions[0].value
        let target = this.productDetailsTarget.id
        let price = this.priceDetailsTarget.id
        let departure = `${this.departuresFieldTarget.value} ${this.departuresHoursFieldTarget.value}`
        let drop = `${this.dropFieldTarget.value} ${this.dropHoursFieldTarget.value}`
        let user_message_area = this.userMessageTarget.id
        let add_airport = false
        let pax_airport = '1'
        if (this.hasPaxAirportSelectTarget) {
            pax_airport = this.paxAirportSelectTarget.value
        }
        let term_and_condition = 'term_and_conditions';
        let additionalDrivers = this.additionalDriversTarget.id;
        let additionalDriversValue = this.additionalDriversTarget.selectedOptions[0].value;

        if (this.hasAirportTarget) {
            add_airport = this.airportTarget.checked
        }

        if (show_load) {
            this.productDetailsTarget.innerHTML = "<span class='fa fa-circle-o-notch fa-spin fa-2x' style='color: var(--first-color)'></span>"
        }


        get(`/admin/get_products_details`, {
            query: {
                id: id_voucher,
                agency: agency,
                destination: destination,
                office: oficina,
                product: product,
                target: target,
                price: price,
                departure: departure,
                drop: drop,
                refresh_details: refresh_details,
                refresh_price: refresh_price,
                refresh_message: refresh_message,
                add_airport: add_airport,
                pax_airport: pax_airport,
                show_description: show_description,
                user_message_area: user_message_area,
                additionalDrivers: additionalDrivers,
                additionalDriversValue: additionalDriversValue,
                term_and_condition: term_and_condition,
                has_terms: false,
                continue: true
            },
            responseKind: "turbo-stream"
        }).then()
    }

    getProductDataForSeason(type = '', less_day = null, show_price = false) {
        let context = this;
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let product = this.productSelectTarget.selectedOptions[0].value;
        let departure = `${this.departuresFieldTarget.value} ${this.departuresHoursFieldTarget.value}`
        let drop = `${this.dropFieldTarget.value} ${this.dropHoursFieldTarget.value}`
        // let checkAvailability = document.querySelector('#checkAvailability');
        // let noCheckAvailability = document.querySelector('#noCheckAvailability');
        // let terms_create_reservation = document.querySelector('#terms-create-reservation');
        // let terms_request_reservation = document.querySelector('#terms-request-reservation');
        // let create_reservation = document.querySelector('#create-reservation');
        // let request_reservation = document.querySelector('#request-reservation');

        $.ajax({
            url: `/admin/get_products_data_for_season`,
            data: {
                agency: agency,
                product: product,
                departure: departure,
                drop: drop,
            },
            type: "GET",
            success: (data) => {
                this.own_product = data.own_product;
                context.hours_diference = data.delay * 24;

                if (this.not_own_product_area.length > 0) {
                    if (data.own_product) {
                        if (this.not_own_product_area.length > 0) {
                            this.not_own_product_area[0].classList.add('ocultar');
                        }
                        // checkAvailability.classList.add('d-none');
                        // noCheckAvailability.classList.remove('d-none')
                        // RELEVO DE RESPONSABILIDAD
                        if (this.hasResponsabilitySupplyTarget) {
                            this.responsabilitySupplyTarget.classList.add('ocultar');
                        }

                    } else {
                        if (this.not_own_product_area.length > 0) {
                            this.not_own_product_area[0].classList.remove('ocultar');
                        }
                        // RELEVO DE RESPONSABILIDAD
                        if (this.hasResponsabilitySupplyTarget) {
                            this.responsabilitySupplyTarget.classList.remove('ocultar');
                        }
                    }
                }
            }
        })
    }

    getAditionalData() {
        let id_voucher = ''
        if ($('#voucher_id') !== undefined) {
            id_voucher = $('#voucher_id').val();
        }
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let product = this.productSelectTarget.selectedOptions[0].value
        let destination = this.destiationsSelectTarget.value;
        let target = this.additionalDataTarget.id

        get(`/admin/get_products_additional`, {
            query: {
                id: id_voucher,
                agency: agency,
                destination: destination,
                product: product,
                target: target,
                edit: true
            },
            responseKind: "turbo-stream"
        }).then()
    }

    getModalities(initial_load) {
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let product = this.productSelectTarget.selectedOptions[0].value;
        let target = this.modalitySelectTarget.id

        get(`/admin/get_modalities`, {
            query: {
                agency: agency,
                product: product,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.setModalityData(initial_load);
        })
    }

    setModalityData(initial_load) {
        if (initial_load) {
            setTimeout(() => {
                if (this.modalitySelectTarget.dataset.value !== undefined) {
                    $(this.modalitySelectTarget).val(this.modalitySelectTarget.dataset.value); // Change the value or make some change to the internal state
                    $(this.modalitySelectTarget).trigger('change.select2');
                }
            }, 500)
        }
    }

    getContracts() {
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let product = this.productSelectTarget.selectedOptions[0].value;
        let dealer = (this.dealerSelectTarget.selectedOptions.length > 0) ? (this.dealerSelectTarget.selectedOptions[0].value || "") : "";
        let target = this.contractSelectTarget.id

        get(`/admin/get_contracts`, {
            query: {
                agency: agency,
                product: product,
                dealer: dealer,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.setContractData();
        })
    }

    setContractData() {
        setTimeout(() => {
            // Contar cantidad de options del select de agencias
            let count_options_contracts = [];
            $(this.contractSelectTarget).find('option').map((index, elem) => {
                if (elem.value.length > 0) {
                    count_options_contracts.push(elem.value);
                }
            })

            if (count_options_contracts.length > 1) {
                if (this.contractSelectTarget.dataset.value !== undefined) {
                    $(this.contractSelectTarget).val(this.contractSelectTarget.dataset.value); // Change the value or make some change to the internal state
                    $(this.contractSelectTarget).trigger('change.select2');
                }
            }
        }, 500)
    }

    getTariffs() {
        let agency = this.agencySelectTarget.selectedOptions[0].value;
        let contract = this.contractSelectTarget.selectedOptions[0].value;
        let target = this.tariffSelectTarget.id

        get(`/admin/get_tariffs`, {
            query: {
                agency: agency,
                contract: contract,
                target: target
            },
            responseKind: "turbo-stream"
        }).then()
    }

}

